export const ACTIVITY_BEGIN_WRITE_DATA = 'ACTIVITY/BEGIN_WRITE_DATA';
export const ACTIVITY_COMPLETE_WRITE_DATA = 'ACTIVITY/COMPLETE_WRITE_DATA';
export const ACTIVITY_REQUEST_DATA = 'ACTIVITY/REQUEST_DATA';
export const RECEIVE_ACTIVITIES = 'ACTIVITY/RECEIVE_ACTIVITIES';
export const DELETE_ACTIVITY = 'ACTIVITY/DELETE_ACTIVITY';
